import { StatusBar } from "expo-status-bar";
import React, { useRef, useState, useEffect } from "react";
import {
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
  Dimensions,
  SafeAreaView,
  Image,
  ImageBackground,
  TextInput,
  FlatList,
} from "react-native";
import Dawer from "../../component/drawer";
import Admin from "../../component/admin";
import InputFree from "../../component/inputfree";
import Calendar from "react-calendar";
import moment from "moment";
import RNPickerSelect, { defaultStyles } from "react-native-picker-select";

import { FontAwesome5 } from "@expo/vector-icons";
import { tokenState } from "../../reducer/reducer/reducer/Atom";
import { useRecoilState } from "recoil";
import S3 from "react-aws-s3";
import { pickImage } from "../../action/authImage";
import { apiservice } from "../../service/service";
const { width, height } = Dimensions.get("window");

export default function createfreepoint({ navigation, route }) {
  const [token, setToken] = useRecoilState(tokenState);
  const [locate, setLo] = useState({});
  const [handelCalendar, setHandelCalendar] = useState(false);
  const [dateState, setDateState] = useState(new Date());
  const [day, setday] = useState(new Date());
  const hiddenFileInputResult = useRef();
  const newFileName = moment().format("DD-MM-YYYY-HH-mm-ss");

  const config = {
    bucketName: "sosorun-pub",
    dirName: "",
    region: "ap-southeast-1",
    accessKeyId: "AKIA5QXMEPVM4GNFXBUN",
    secretAccessKey: "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",
  };

  const ReactS3Client = new S3(config);

  const handleClickResult = (event) => {
    hiddenFileInputResult.current.click();
  };

  const handleChangeResult = (event) => {
    const fileUploaded = event.target.files[0];

    const url = URL.createObjectURL(fileUploaded);

    if (fileUploaded.name.includes(".mp4")) {
      // setshowResults(require("../../img/film.png"));
    } else {
      setshowResults({ uri: url });
    }

    setbody((val) => ({
      ...val,
      link_url:
        "https://sosorun-pub.s3.ap-southeast-1.amazonaws.com/" +
        newFileName +
        "." +
        fileUploaded.name.split(".").reverse()[0],
    }));

    ReactS3Client.uploadFile(fileUploaded, newFileName)
      .then((data) => console.log(data))
      .catch((err) => console.log(err));
  };

  const changeDate = (e) => {
    setDateState(e);
  };
  const [locate1, setLo1] = useState({});
  const [handelCalendar1, setHandelCalendar1] = useState(false);
  const [dateState1, setDateState1] = useState(new Date());
  const [day1, setday1] = useState(new Date());
  const changeDate1 = (e) => {
    setDateState1(e);
  };

  useEffect(() => {
    if (route?.params?.id) {
      setbody(route?.params);
    }
  }, []);

  const placeholder = {
    label: "สถานะ",
    value: null,
    color: "#777777",
  };
  const [items, setItems] = useState([
    { label: "Active", value: "Active" },
    { label: "Inactive", value: "Inactive" },
  ]);

  async function PickImg() {
    const response = await pickImage();
    console.log(response);
  }

  const [body, setbody] = useState({
    url: null,
    name: "",
    count: "",
    reward: [{ coin: "" }],
    link_url: "",
    status: true,
    description: "",
    startDate: new Date(),
    expireDate: new Date(),
    Type: "",
  });
  console.log(body);
  return (
    <View style={styles.container}>
      <Dawer navigation={navigation} />
      <View style={styles.back}>
        <Admin />
        <View style={styles.viewfree}>
          <Text style={styles.textfree}>
            FREE POINT{" "}
            <Text style={styles.textfree1}>
              / <Text style={styles.textfree1}>ADD</Text>
            </Text>
          </Text>
          <View style={styles.viewtouch}>
            <TouchableOpacity
              onPress={async () => {
                if (body?.id) {
                  const res = await apiservice({
                    path: "/freepoint/deletefreepoint?id=" + body?.id,
                    method: "delete",
                    token: token?.accessToken,
                  });
                  delete body?.id;
                  if (res?.status == 200) {
                    const response = await apiservice({
                      path: "/freepoint/postfreepoint",
                      method: "post",
                      body,
                      token: token?.accessToken,
                    });

                    if (response.status == 200) {
                      navigation.goBack();
                    }
                  }
                } else {
                  const response = await apiservice({
                    path: "/freepoint/postfreepoint",
                    method: "post",
                    body,
                    token: token?.accessToken,
                  });

                  if (response.status == 200) {
                    navigation.goBack();
                  }
                }
              }}
              style={styles.touchadd}
            >
              <Text style={styles.textadd}>บันทึก</Text>
            </TouchableOpacity>
            <TouchableOpacity
              onPress={() => {
                navigation.goBack();
              }}
              style={styles.touchadd}
            >
              <Text style={styles.textadd}>ยกเลิก</Text>
            </TouchableOpacity>
          </View>
        </View>
        <View style={styles.view}>
          <View style={styles.viewin}>
            <InputFree
              name="ชื่อรายการ"
              placeholder="กรอกชื่อรายการ"
              value={body?.name}
              onChangeText={(text) => {
                setbody({ ...body, name: text });
              }}
            />
            <InputFree
              name="รายละเอียด"
              placeholder="กรอกรายละเอียด"
              value={body?.description}
              onChangeText={(text) => {
                setbody({ ...body, description: text });
              }}
            />
            <InputFree
              name="จำนวนในการแสดงผล"
              placeholder="กรอกจำนวนเป็นตัวเลข"
              value={body?.count}
              onChangeText={(text) => {
                setbody({ ...body, count: text });
              }}
            />
            <View style={[styles.kob, { width: width * 0.395 }]}>
              <Text style={styles.textname}>รูปหน้าปก</Text>
              <View style={styles.style}>
                {body.url == null ? (
                  <View style={styles.viewimg} />
                ) : (
                  <Image
                    style={{ width: 150, height: 70, alignSelf: "center" }}
                    source={{
                      uri: body.url,
                    }}
                  />
                )}

                <View style={{ marginLeft: 20 }}>
                  <View style={{ flexDirection: "row" }}>
                    <TouchableOpacity
                      onPress={async () => {
                        const response = await pickImage();
                        setbody({ ...body, url: response });
                      }}
                      style={[styles.tochup, { backgroundColor: "#FCC81D" }]}
                    >
                      <Text style={styles.textup}>Upload</Text>
                    </TouchableOpacity>
                    <TouchableOpacity
                      style={[styles.tochup, { marginLeft: 20 }]}
                    >
                      <Text style={styles.textup}>Reset</Text>
                    </TouchableOpacity>
                  </View>
                  <Text style={styles.textRe}>
                    Required image resolution 800x400, image size 10mb.
                  </Text>
                </View>
              </View>
            </View>
          </View>
          <View style={styles.viewin}>
            <View
              style={[
                styles.style,
                { justifyContent: "space-between" },
                { marginRight: 5 },
              ]}
            >
              <View>
                <Text style={[styles.textname, { marginBottom: 5 }]}>
                  สถานะ
                </Text>
                <RNPickerSelect
                  placeholder={placeholder}
                  value={body?.Type}
                  onValueChange={(text) => setbody({ ...body, Type: text })}
                  style={{
                    inputWeb: {
                      width: width * 0.18,
                      height: 30,
                      borderWidth: 1,
                      borderColor: "#ccc",
                      paddingLeft: 10,
                      borderRadius: 5,
                      color: "#777777",
                      fontFamily: "Prompt-Regular",
                      alignSelf: "center",
                    },
                  }}
                  items={items}
                />
              </View>
              <View>
                <Text style={[styles.textname, { marginBottom: 5 }]}>
                  แสดงผลวันที่
                </Text>
                <View style={{ flexDirection: "row" }}>
                  <TextInput
                    style={{
                      width: width * 0.18,
                      height: 30,
                      backgroundColor: "#fff",
                      borderWidth: 1,
                      borderColor: "#D9D9D9",
                      paddingLeft: 25,
                      borderRadius: 5,
                      color: "#777777",
                      fontFamily: "Prompt-Regular",
                      alignSelf: "center",
                    }}
                    type={true}
                    Locate={locate}
                    setLo={setLo}
                    setHandelCalendar={setHandelCalendar}
                    value={moment(body?.startDate).format("DD/MM/YYYY")}
                    onChangeText={(text) => {
                      setbody({ ...body, startDate: text });
                    }}
                  />
                  <TouchableOpacity
                    onPress={() => {
                      setHandelCalendar((val) => !val);
                    }}
                    style={styles.botton}
                  >
                    <FontAwesome5
                      name="calendar-alt"
                      size={18}
                      color="#AFAFAF"
                    />
                  </TouchableOpacity>
                </View>
                <View style={{ flexDirection: "row" }}>
                  <TextInput
                    style={{
                      width: width * 0.18,
                      height: 30,
                      backgroundColor: "#fff",
                      borderWidth: 1,
                      borderColor: "#D9D9D9",
                      paddingLeft: 25,
                      borderRadius: 5,
                      color: "#777777",
                      fontFamily: "Prompt-Regular",
                      alignSelf: "center",
                    }}
                    type={true}
                    Locate={locate1}
                    setLo={setLo1}
                    setHandelCalendar={setHandelCalendar1}
                    value={moment(body?.expireDate).format("DD/MM/YYYY")}
                    onChangeText={(text) => {
                      setbody({ ...body, expireDate: text });
                    }}
                  />
                  <TouchableOpacity
                    onPress={() => {
                      setHandelCalendar1((val) => !val);
                    }}
                    style={styles.botton}
                  >
                    <FontAwesome5
                      name="calendar-alt"
                      size={18}
                      color="#AFAFAF"
                    />
                  </TouchableOpacity>
                </View>
              </View>
            </View>

            <Text style={[styles.textname, { marginVertical: 10 }]}>
              ของรางวัล
            </Text>
            <View
              style={{
                width: width * 0.39,
                flexDirection: "row",
                justifyContent: "space-between",
                marginTop: 10,
              }}
            >
              <Text style={styles.textname}>โกลด์</Text>
              <TextInput
                value={body?.reward?.[0]?.coin}
                onChangeText={(text) => {
                  setbody({ ...body, reward: [{ coin: text }] });
                }}
                placeholder="กรอกเป็นตัวเลข"
                style={{
                  width: width * 0.3,
                  height: 30,
                  fontFamily: "Prompt-Regular",
                  borderWidth: 1,
                  borderColor: "#ccc",
                  paddingLeft: 10,
                  borderRadius: 5,
                  marginRight: 15,
                  alignSelf: "center",
                }}
              />
            </View>

            <View
              style={[styles.kob, { marginTop: 27 }, { width: width * 0.38 }]}
            >
              <Text style={styles.textname}>URL</Text>

              <TouchableOpacity
                onPress={handleClickResult}
                style={styles.buttonUploadImgModal}
              >
                <input
                  type="file"
                  ref={hiddenFileInputResult}
                  onChange={handleChangeResult}
                  style={{ display: "none" }}
                />
                <View style={styles.viewinput}>
                  <Text style={styles.input}>{body?.link_url}</Text>
                </View>
              </TouchableOpacity>
            </View>
          </View>
        </View>
      </View>
      {handelCalendar && (
        <View
          style={{
            width: width * 0.18,
            position: "absolute",
            top: height * 0.32,
            left: width * 0.8,
          }}
        >
          <Text
            style={{
              fontSize: 10,
              color: "#000",
              textAlign: "center",
              fontFamily: "Prompt-Regular",
            }}
          >
            <Calendar
              value={dateState}
              onChange={changeDate}
              onChangeText={(text) => {
                setbody({ ...body, startDate: text });
              }}
              onClickDay={(e) => {
                setday(e);
                setbody({ ...body, startDate: e });
                setTimeout(() => {
                  setHandelCalendar((val) => !val);
                }, 500);
              }}
            />
          </Text>
        </View>
      )}
      {handelCalendar1 && (
        <View
          style={{
            width: width * 0.18,
            position: "absolute",
            zIndex: 99,
            top: height * 0.35,
            left: width * 0.8,
          }}
        >
          <Text
            style={{
              fontSize: 10,
              color: "#000",
              textAlign: "center",
              fontFamily: "Prompt-Regular",
            }}
          >
            <Calendar
              value={dateState1}
              onChange={changeDate1}
              onChangeText={(text) => {
                setbody({ ...body, expireDate: text });
              }}
              onClickDay={(a) => {
                setday1(a);
                setbody({ ...body, expireDate: a });
                setTimeout(() => {
                  setHandelCalendar1((val) => !val);
                }, 500);
              }}
            />
          </Text>
        </View>
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    width: width,
    height: height,
    backgroundColor: "#F3F3F3",
    flexDirection: "row",
  },
  back: {
    width: width * 0.85,
    height: height,
    paddingHorizontal: width * 0.01,
  },
  viewfree: {
    justifyContent: "space-between",
    width: width * 0.83,
    flexDirection: "row",
  },
  textfree: {
    fontFamily: "Prompt-Regular",
    fontSize: 25,
    color: "#000",
    fontWeight: "bold",
    alignSelf: "center",
  },
  textfree1: {
    fontFamily: "Prompt-Regular",
    fontSize: 20,
    color: "#000",
    alignSelf: "center",
  },
  touchadd: {
    width: 150,
    height: 40,
    justifyContent: "center",
    backgroundColor: "#fff",
    alignSelf: "center",
  },
  textadd: {
    fontFamily: "Prompt-Regular",
    fontSize: 16,
    color: "#172B4D",
    alignSelf: "center",
  },
  viewtouch: {
    flexDirection: "row",
    width: width * 0.35,
    justifyContent: "space-between",
    marginRight: 20,
  },
  view: {
    width: width * 0.83,
    height: height * 0.8,
    borderWidth: 0.05,
    borderColor: "#00000010",
    backgroundColor: "#fff",
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
    marginTop: 10,
    flexDirection: "row",
    justifyContent: "space-between",
  },
  viewin: {
    width: width * 0.41,
    padding: 20,
    backgroundColor: "#ffffff",
  },
  kob: {
    height: 120,
    fontFamily: "Prompt-Regular",
    borderWidth: 1,
    borderColor: "#ccc",
    paddingLeft: 10,
    borderRadius: 5,
    marginTop: 20,
    marginBottom: 10,
  },
  textname: {
    fontSize: 18,
    color: "#000000",
    fontFamily: "Prompt-Regular",
  },
  style: {
    flexDirection: "row",
    marginTop: 5,
  },
  viewimg: {
    width: 150,
    height: 70,
    borderWidth: 0.5,
    borderColor: "#DBDBDB",
    borderRadius: 5,
    alignSelf: "center",
  },
  tochup: {
    width: 120,
    height: 40,
    borderRadius: 5,
    borderWidth: 0.5,
    borderColor: "#DBDBDB",
    justifyContent: "center",
  },
  textup: {
    fontSize: 16,
    color: "#000000",
    fontFamily: "Prompt-Regular",
    alignSelf: "center",
  },
  textRe: {
    fontSize: 12,
    color: "#000000",
    fontFamily: "Prompt-Regular",
    marginTop: 10,
  },
  touchlong: {
    width: width * 0.18,
    height: 30,
    borderWidth: 1,
    borderColor: "#ccc",
    paddingLeft: 10,
    borderRadius: 5,
  },
  touchheigh: {
    width: width * 0.38,
    height: 30,
    borderWidth: 1,
    borderColor: "#ccc",
    paddingLeft: 10,
    borderRadius: 5,
  },
  input: {
    width: width * 0.38,
    height: 33,
    fontFamily: "Prompt-Regular",
    borderWidth: 1,
    borderColor: "#ccc",
    paddingLeft: 10,
    borderRadius: 5,
    marginTop: 5,
    marginBottom: 10,
  },
  viewinput: {
    flexDirection: "row",
    width: width * 0.36,
    justifyContent: "space-between",
    paddingTop: 15,
  },
  botton: {
    alignSelf: "center",
    marginLeft: -25,
  },
  viewimglogo: {
    width: 70,
    height: 70,
    borderWidth: 0.5,
    borderColor: "#DBDBDB",
    borderRadius: 5,
    alignSelf: "center",
  },
  logo: {
    width: width * 0.24,
    height: 85,
    fontFamily: "Prompt-Regular",
    borderWidth: 1,
    borderColor: "#ccc",
    paddingLeft: 10,
    borderRadius: 5,
    marginTop: 10,
    marginBottom: 10,
    flexDirection: "row",
  },
  touchsmall: {
    backgroundColor: "#FCC81D",
    width: 60,
    height: 30,
    borderRadius: 5,
    borderWidth: 0.5,
    borderColor: "#DBDBDB",
    justifyContent: "center",
  },
  textsmall: {
    fontSize: 12,
    color: "#000000",
    fontFamily: "Prompt-Regular",
    alignSelf: "center",
  },
  textmini: {
    fontSize: 9,
    color: "#000000",
    fontFamily: "Prompt-Regular",
    marginTop: 10,
  },
  backmodal: {
    width: width,
    height: height,
    backgroundColor: "#000000bb",
    justifyContent: "center",
  },
  viewinmodail: {
    width: width * 0.5,
    alignSelf: "center",
    justifyContent: "center",
    backgroundColor: "#fff",
    paddingVertical: 30,
  },
  imgko: {
    width: 25,
    height: 25,
    position: "absolute",
    alignSelf: "center",
  },
  line: {
    width: width * 0.5,
    borderBottomWidth: 0.5,
    borderColor: "#44444440",
    marginTop: 10,
  },
  liner: {
    flexDirection: "row",
    width: width * 0.48,
    justifyContent: "space-between",
    height: 40,
    borderLeftWidth: 1,
    borderLeftColor: "#2DCE98",
    marginTop: 10,
    alignSelf: "center",
  },
  ok: {
    width: 40,
    height: 40,
    borderWidth: 0.5,
    borderColor: "#DBDBDB",
    borderRadius: 5,
    justifyContent: "center",
    marginRight: 10,
  },
});
